import "@babel/polyfill";
import "isomorphic-fetch"
import Vue from 'vue'
import App from './App.vue'
import VueMeta from 'vue-meta'
import Vuetify from 'vuetify'
import VCurrencyField from 'v-currency-field'
import VueCurrencyFilter from 'vue-currency-filter'
import vClickOutside from 'v-click-outside'
import VueMobileDetection from 'vue-mobile-detection'
import VueRouter from 'vue-router'
import routes from './routes'

import '../node_modules/vuetify/dist/vuetify.min.css'
import './styles.scss'
require('./assets/favicon.ico')

const opts = { 
  icons: {
    iconfont: 'mdiSvg'
  }
}

Vue.use (VueMeta)

Vue.use(VueRouter)

Vue.use(Vuetify)

Vue.use(vClickOutside)

Vue.use(VueMobileDetection)

Vue.use(VueCurrencyFilter,
  {
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 0,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false,
    avoidEmptyDecimals: undefined
  })

Vue.use(VCurrencyField,
  {
    locale: 'en-US',
    decimalLength: 0,
    autoDecimalMode: false,
    min: null,
    max: null,
    defaultValue: 0,
    valueAsInteger: true,
    allowNegative: false,
    prefix: '$'
  })

const router = new VueRouter({
    mode: 'history',
    routes: routes
})

router.beforeResolve((to, from, next) => {
    if (
        from.name === 'declined'
        || from.name === 'referred'
        || from.name === 'success'
        || from.name === 'approved'
        || from.name === 'dd-declined'
        || from.name === 'dd-referred'
        || from.name === 'dd-success'
        || from.name === 'dd-approved') { 
    // We dont allow user to go back from one of outcome pages
    window.location.href = window.location.origin
  }
  else next()
})

// eslint-disable-next-line no-new
var vm = new Vue({
  router,
  el: '#app',
  vuetify: new Vuetify(opts),
  render: h => h(App)
})

global.vm = vm;